module.exports = __webpack_public_path__ + "static/media/kp.5e8ce619.svg";